import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { AdmihairBaseComponent } from "../../../admihair-base.component";
import { ErroService } from "src/app/admihair/service/erro.service";
import { UtilStorageService } from "src/app/admihair/service/util-storage.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Patrimonio } from "src/app/admihair/api/dto/patrimonio";
import { Table } from "primeng/table";
import { PageResponse } from "src/app/admihair/api/dto/paginacao/page-response";
import { ConfirmationService, LazyLoadEvent } from "primeng/api";
import { PatrimonioService } from "src/app/admihair/service/patrimonio.service";

@Component({
    selector: "app-patrimonio-listar",
    templateUrl: "./patrimonio-listar.component.html",
    styleUrls: ["./patrimonio-listar.component.scss"],
})
export class PatrimonioListarComponent extends AdmihairBaseComponent implements OnInit {

    @ViewChild("filter") filter!: ElementRef;
    loading: boolean = true;
    patrimonios: Patrimonio[] = [];
    empresaId!: number;

    itensPaginados: PageResponse<Patrimonio> = {
        content: [],
        number: 0,
        size: 0,
        totalElements: 0,
        totalPages: 0,
        last: false
    }
    numeroPagina: number = 0;
    tamanhoPagina: number = 10;
    inputBusca?: string = "";
    ordenacao: string = "descricao,ASC";
    situacao?: string;

    constructor(
        private patrimonioService: PatrimonioService,
        private confirmationService: ConfirmationService,
        erroService: ErroService,
        storageService: UtilStorageService,
        router: Router,
        activatedRoute: ActivatedRoute
    ) {
        super(erroService, storageService);
    }

    ngOnInit(): void {
        this.empresaId = this.getEmpresa().id!
        this.verificarPermissoes();
    }

    verificarPermissoes() {
        this.permissaoListar = this.verificarPermissao('PERM_LISTAR_PATRIMONIO');
        this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_PATRIMONIO');
        this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_PATRIMONIO');
        this.permissaoExcluir = this.verificarPermissao('PERM_EXCLUIR_PATRIMONIO');
    }

    onLazyLoad(event: LazyLoadEvent) {
        if (event.first !== undefined && event.rows !== undefined) {
            if (event.first === 0 && event.rows === 0) {
                this.numeroPagina = 0;
            } else {
                this.numeroPagina = event.first / event.rows;
            }
        }
        this.definirOrdenacao(event.sortField, event.sortOrder);
        this.listar();
    }

    listar() {
        this.patrimonioService.listarPorEmpresa(
            this.empresaId,
            this.numeroPagina,
            this.tamanhoPagina,
            this.ordenacao,
            this.inputBusca,
            this.situacao

        ).subscribe({
            next: (data: PageResponse<Patrimonio>) => {
                this.itensPaginados = data;
                this.loading = false;
            },
            error: (err: any) => {
                this.loading = false;

            }
        })
    }

    definirOrdenacao(sortField?: string, sortOrder?: number) {
        const campoDeOrdenacao = sortField ? sortField : "descricao";
        const direcaoOrdenacao = sortOrder === -1 ? "DESC" : "ASC";
        this.ordenacao = `${campoDeOrdenacao},${direcaoOrdenacao}`;
    }


    buscar(table: Table, event: Event) {
        table.filterGlobal((event.target as HTMLInputElement).value, "contains");
    }

    limpar(table: Table) {
        table.clear();
        this.filter.nativeElement.value = "";
    }


    excluir(item: number) {
        this.confirmationService.confirm({
            message: "Tem certeza que deseja excluir?",
            header: "Confirmação",
            acceptLabel: "Sim",
            rejectLabel: "Não",
            icon: "pi pi-info-circle",
            accept: () => {
                this.loading = true;
                this.patrimonioService.excluir(item).subscribe({
                    next: () => {
                        this.listar();
                        this.exibirMensagemSucesso();
                    },
                    error: (err: any) => {
                        this.loading = false;
                        this.exibirMensagemErro(err);
                    }
                }
                );
            },
        });
    }
}
